import React, { createContext, useContext, ReactNode } from "react";
import { useEntregaResumo } from "../../hooks/useEntrega";
import { EntregaResumo } from "../../services/entregaService";

interface EntregaContextData {
  data: EntregaResumo | undefined;
  isLoading: boolean;
}

interface EntregaProviderProps {
  children: ReactNode;
  dataInicio: string;
  dataFim: string;
  lojaId?: number | null;
}

const EntregaContext = createContext<EntregaContextData>(
  {} as EntregaContextData
);

export const EntregaProvider: React.FC<EntregaProviderProps> = ({
  children,
  dataInicio,
  dataFim,
  lojaId,
}) => {
  const { data, isLoading } = useEntregaResumo({
    dataInicio,
    dataFim,
    lojaId: lojaId || undefined,
  });

  return (
    <EntregaContext.Provider value={{ data, isLoading }}>
      {children}
    </EntregaContext.Provider>
  );
};

export const useEntregaContext = () => {
  const context = useContext(EntregaContext);
  if (!context) {
    throw new Error("useEntregaContext must be used within an EntregaProvider");
  }
  return context;
};
